import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import PropTypes from 'prop-types';
// import classnames from 'classnames';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
// import Divider from '@material-ui/core/Divider';
// import red from '@material-ui/core/colors/red';
// import Button from 'components/CustomButtons/Button.jsx';
// images
// import avatarImg from "images/avatars/avatar_me.jpg";
// import Avatar from "@material-ui/core/Avatar";

import {
  Phone,
  MailOutline
} from '@material-ui/icons';

// import { Facebook, Google, Twitter, GithubCircle } from 'mdi-material-ui';

const styles = theme => ({
  label: {
    marginRight: '10px'
  },
  avatar: {
    width: '200px',
    height: '200px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginBottom: "50px"
  }
});

class UserTrack extends React.Component {
  state = { expanded: false };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container
        // alignItems='center'
        spacing={8}
        justify="flex-start">

            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <MailOutline className={classes.label}>Email:</MailOutline>
              <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
                alciato@gmail.com
              </Typography>
            </Grid>

            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <Phone className={classes.label}>Phone:</Phone>
              <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
                555 5555 5555
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="h6"  color="textSecondary" gutterBottom>
                Address:
              </Typography>
              <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
                Wall Street Avn. 55, NY  - ZIP 22000
              </Typography>
            </Grid>

            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <Typography className={classes.label} inline align="left" variant="h6"  color="textSecondary" gutterBottom>
                ID:
              </Typography>
              <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
                5644345567-G DNI
              </Typography>
            </Grid>

            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <Typography className={classes.label} inline align="left" variant="h6"  color="textSecondary" gutterBottom>
                VAT number:
              </Typography>
              <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
                5644345567-G ES
              </Typography>
            </Grid>

            <Grid item
            lg={1}
            md={1}
            xl={1}
            xs={1}>
            <Typography className={classes.label} inline align="left" variant="h6"  color="textSecondary" gutterBottom>
              Locale:
            </Typography>
            <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
              ES
            </Typography>
            </Grid>

            <Grid item
            lg={1}
            md={1}
            xl={1}
            xs={1}>
            <Typography className={classes.label} inline align="left" variant="h6"  color="textSecondary" gutterBottom>
              Lang:
            </Typography>
            <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
              ES
            </Typography>
            </Grid>

            <Grid item
            lg={9}
            md={9}
            xl={9}
            xs={9}>
              <Typography className={classes.label} inline align="left" variant="h6"  color="textSecondary" gutterBottom>
                Languages:
              </Typography>
              <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
                Spanish: Native, English: Hight Spoken and Writen, French: Basic, German: Basic
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="h6"  color="textSecondary" gutterBottom>
                Notes:
              </Typography>
              <Typography inline align="left" variant="subtitle1"  color="textSecondary" gutterBottom>
                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
              </Typography>
            </Grid>










        :public_name
        :public_description

        ## Trackable
        :sign_in_count, default: 0, null: false
        :current_sign_in_at
        :last_sign_in_at
        :current_sign_in_ip
        :last_sign_in_ip


        ## Lockable
        :failed_attempts, default: 0, null: false # Only if lock strategy is :failed_attempts
        :locked_at
        t.timestamps null: false

    </Grid>

    );
  }
}

UserTrack.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UserTrack);
